var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7 12h5m0 0h5m-5 0v-5m0 5v5","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Plus.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Plus;

Plus.default = Plus;
